import { skipToken } from '@reduxjs/toolkit/query';
import { useGetVehicleId } from 'pages/CreateVehicle/hooks/useGetVehicleId';
import { useGetSectionsQuery } from 'services/api/vehicle-sections';
import { Section, SectionImage } from 'services/api/vehicle-sections/types';
import { useLevel1SectionData } from './useLevel1Section';

const UNDER_HOOD_SKIP_KEYS = new Set([
  'under_hood_3_point_body_lines_paint_check',
  'frame_fit_finish_under_hood',
]);

export const useUnderHoodSection = (): { section: Section | undefined; images: SectionImage[] } => {
  const vehicleId = useGetVehicleId();
  const { data: sections } = useGetSectionsQuery(vehicleId || skipToken);
  const { subSections, images } = useLevel1SectionData('under_hood');

  const rawSection = sections?.under_hood;
  const subsections: Record<string, Section> = {};
  Object.entries(subSections).forEach(([key, sub]) => {
    if (!UNDER_HOOD_SKIP_KEYS.has(key) && sub.grade) subsections[key] = sub as Section;
  });

  return {
    section: rawSection ? { ...rawSection, subsections } : undefined,
    images,
  };
};
